import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withEditFunctionality } from 'components/Portfolio/PortfolioAbout/components/hoc/withEditFunctionality';
import { EditableSliderBar } from 'components/Shared/Sliders/EditableSliderBar/EditableSliderBar';
import styles from './Experience.module.scss';
import { getLinkToFindPage } from 'helpers/HelperFunctions';

@withEditFunctionality
export default class Experience extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    editMode: PropTypes.bool,
    updateData: PropTypes.func,
    loggedInUser: PropTypes.object,
    isOwner: PropTypes.bool,
  };

  updateExperience = (exp, index) => {
    const { data: skills, updateData: updateExperience } = this.props;
    skills[index].experience = exp;
    updateExperience(skills);
  };

  render() {
    const { data: skills, editMode, loggedInUser, isOwner } = this.props;
    const userType = loggedInUser ? loggedInUser.type : 'guest';

    if (skills.length === 0) {
      return null;
    }

    // Clients read levels from the skill rings, so this only shows to owners.
    if (!editMode) {
      return (
        <p className={styles.hint}>
          The ring around each skill shows the level you set. Clients see it on
          your portfolio.
        </p>
      );
    }

    return (
      <div id="portfolio-skills" className={styles.sliders}>
        <p className={styles.hint}>
          Skills will be reordered by experience level once saved.
        </p>
        {skills.map((skill, index) => {
          const { linkToFindPage, url } = getLinkToFindPage(skill, userType);
          return (
            <EditableSliderBar
              key={`LanguageBar${index}`}
              id={index}
              isLast={index === skills.length - 1}
              experience={skill.experience}
              barName={skill.name}
              linkBarName={linkToFindPage}
              link={url}
              showBar={skill.experience || isOwner}
              editMode={editMode}
              updateFunction={this.updateExperience}
            />
          );
        })}
      </div>
    );
  }
}
